import { FC } from 'react';
import { TAny } from '../../types/blog';
import './hidenUpload.scss';
interface IUpload {
  handleChangeFile: (file: TAny) => void;
}
const HidenUpload: FC<IUpload> = ({ handleChangeFile }: IUpload) => {
  return (
    <input
      id="hidenUpload"
      type="file"
      onChange={e => {
        handleChangeFile(e);
      }}
    />
  );
};
export default HidenUpload;
